import { FEED_KIND, feedKey, type FeedKind } from './feedContext';

/** Data caches and fork state still belong to their source. Only preferences
 * are shared by the main live/prematch/5.0 screen and BetBurger 2.0. */
export function preferenceScope(kind: FeedKind): FeedKind {
  return kind === 'tests' ? 'main' : kind;
}

const LEGACY_KEYS = [
  'forq.next.settings', 'forq.next.polyWallet', 'forq.next.alarm', 'forq.next.show',
  'forq.next.filters.v2', 'forq.next.filters.v2.live', 'forq.next.filters.v2.prematch',
  'forq.next.filters.entry-free', 'forq.next.profile.v2', 'forq.next.profile.skip',
  'forq.next.profile.work-rub-mix',
];
const MIGRATED = 'forq.next.shared-preferences.v1';

/** Keep existing main choices; recover 2.0-only preferences where main has no
 * saved value. Never delete the old records. A marker prevents resurrecting a
 * deliberately removed profile on a later visit. */
export function migrateFeedPreferences(): void {
  try {
    if (localStorage.getItem(MIGRATED) === '1') return;
    const hasMainFilters = ['forq.next.filters.v2', 'forq.next.filters.v2.live', 'forq.next.filters.v2.prematch']
      .some(key => localStorage.getItem(key) !== null);
    const hasMainProfile = localStorage.getItem('forq.next.profile.v2') !== null ||
      localStorage.getItem('forq.next.profile.skip') !== null;
    for (const key of LEGACY_KEYS) {
      if (hasMainFilters && key.startsWith('forq.next.filters.v2')) continue;
      if (hasMainProfile && key.startsWith('forq.next.profile.')) continue;
      if (localStorage.getItem(key) !== null) continue;
      const old = localStorage.getItem(feedKey(key, 'tests'));
      if (old !== null) localStorage.setItem(key, old);
    }
    localStorage.setItem(MIGRATED, '1');
  } catch { /* Read-only storage must not prevent opening the feed. */ }
}

export function preferenceKey(key: string): string {
  return feedKey(key, preferenceScope(FEED_KIND));
}

if (preferenceScope(FEED_KIND) === 'main') migrateFeedPreferences();
